<template>
  <pl-dialog :size="'confirm_size'">
    <div class="h-full flex-grow">
      <div class="flex flex-col text-center bg-emerald-50 rounded-t-lg py-12">
        <span>
          <i class="text-6xl fa fa-solid fa-check-circle text-emerald-600"></i>
        </span>
      </div>
      <div class="flex flex-col space-y-8 py-6 px-5">
        <div class="text-center flex flex-col space-y-4">
          <span class="text-lg text-gray-700">You've successfully created a Course!</span>
          <div class="text-gray-700 font-poppins font-light"> 
            Go to <span @click="handleGoToSettings()" class="text-pinky hover:underline cursor-pointer">Course Settings</span> to set up a new LMS integration.
          </div>
        </div>
        <button @click="handleGoToCoursePage()" class="bg-emerald-500 hover:bg-emerald-600 rounded-md text-white px-2.5 py-2">Okay!</button>
      </div>
    </div>
  </pl-dialog>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  export default Vue.extend({
    computed: {
      ...mapGetters(['getCourseDetail']),
    },
    methods: {
      handleGoToSettings: async function() {
        this.$store.commit('setFecthComponent', true);
        const route = {
          name: 'course.settings.general',
          params: {
            courseID: this.getCourseDetail.id,
          },
        };
        this.$router.push(route);
        this.$emit('close');
      },
      handleGoToCoursePage: async function() {
        this.$router.push({
          name: 'course.index',
          params: { courseID: this.getCourseDetail.id },
        });
        this.$emit('close');
      },
    },
  });
</script>



// WEBPACK FOOTER //
// courseCreatedModal.vue?c6c80266